module.exports = __webpack_public_path__ + "static/media/New SVG-5.d743c2c2.png";